import React from "react";
import { Box, Typography } from "@mui/material";
import { ErrorOutlineRounded } from "@mui/icons-material";
import type { SxProps, Theme } from "@mui/material";

interface WarningCalloutProps {
  children: React.ReactNode;
  /** Extra styles merged onto the outer container (e.g. margins). */
  sx?: SxProps<Theme>;
}

/**
 * High-visibility amber warning callout with a circular exclamation icon.
 * Presentational only — gate visibility (e.g. UK-only) at the call site.
 */
export const WarningCallout: React.FC<WarningCalloutProps> = ({ children, sx }) => {
  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: { xs: "8px 12px", md: "10px 14px" },
        backgroundColor: "#FFF4E5",
        border: "1px solid #FFB74D",
        borderRadius: "8px",
        ...sx,
      }}
    >
      <ErrorOutlineRounded sx={{ color: "#B26A00", fontSize: 20, flexShrink: 0 }} />
      <Typography
        sx={{
          fontFamily: "Roobert",
          fontSize: { xs: "13px", md: "14px" },
          lineHeight: 1.5,
          color: "#663C00",
          "& a": {
            color: "#663C00",
            fontWeight: 600,
            textDecoration: "underline",
          },
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default WarningCallout;
